import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {namespaces, resources} from '@mybake/ui/i18n/resources';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,

        fallbackLng: 'pl',

        ns: namespaces as unknown as string[],

        supportedLngs: [
            'en',
            'pl',
            'ru',
            'uk',
        ],

        nonExplicitSupportedLngs: true,

        load: 'languageOnly',

        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'lng',
            caches: ['localStorage'],
        },

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
